import {
	GET_ORDER_SUCCESS,
	GET_ORDER_ERROR,
	UPDATE_ORDER_SUCCESS,
	UPDATE_ORDER_ERROR,
	GET_ORDER_VALUE_SUCCESS,
	GET_ORDER_VALUE_ERROR,
	GET_ORDER_VALUE_START
} from '../../actionType';

import { combineReducers } from 'redux';

const data = (state = [], { type, payload }) => {
	switch (type) {
		case GET_ORDER_SUCCESS:
			return payload;
		case GET_ORDER_ERROR:
			return payload;
		case UPDATE_ORDER_SUCCESS:
			return payload;
		case UPDATE_ORDER_ERROR:
			return payload;
		default:
			return state;
	}
};

const value = (state = {}, { type, payload }) => {
	switch (type) {
		case GET_ORDER_VALUE_SUCCESS: {
			const deliveryPriceFormatted = formatDeliveryPrice(payload.deliveryPrice);
			const formattedDiscountValue = formatDiscountValue(payload.discount,payload.deliveryDiscount,payload.deliveryPrice);
			const formattedPixDiscountValue = formatDiscountValue(payload.pixDiscount,payload.deliveryDiscount,payload.deliveryPrice)
			return {...payload, formattedDiscountValue, deliveryPriceFormatted, formattedPixDiscountValue};
		}
		case GET_ORDER_VALUE_ERROR:
			return payload;
		default:
			return state;
	}
};

const loading = (state = false, { type }) => {
	switch (type) {
		case GET_ORDER_VALUE_START:
			return true; 
		case GET_ORDER_VALUE_SUCCESS:
		case GET_ORDER_VALUE_ERROR:
			return false; 
		default:
			return state;
	}
};

const formatDeliveryPrice = (deliveryPrice) => {
	const locale = 'pt-BR';
	const currency = 'BRL';
	const fullCurrencyFormat = new Intl.NumberFormat(locale, {style: 'currency', currency: currency});
	return (deliveryPrice == null || !(deliveryPrice > 0)) ? 'Grátis' : fullCurrencyFormat.format(deliveryPrice);
}

const formatDiscountValue = (discount, deliveryDiscount, deliveryPrice) => {
	const locale = 'pt-BR';
	const currency = 'BRL';
	const fullCurrencyFormat = new Intl.NumberFormat(locale, {style: 'currency', currency: currency});
	if (discount > 0) {
		return `- ${fullCurrencyFormat.format(discount)}`;
	} else if (deliveryDiscount > 0 && deliveryPrice > 0) {
			return `- ${fullCurrencyFormat.format(deliveryDiscount)}`;
	}
	return null;
}

export default combineReducers({
	data,
	value,
	loading
});
